import { z } from 'zod';

import { ValueType } from './_campaigns/campaignBuilder.js';

export const BuyingPlanLiteSchema = z.object({
  id: z.number(),
  name: z.string(),
  dateFrom: z.string(),
  dateTo: z.string(),
  campaignCollection: z.number(),
  budget: z.number().nullable(),
});

export const BuyingPlanLiteListSchema = z.array(BuyingPlanLiteSchema);
const MetaItemSchema = z.object({
  name: z.string(),
  label: z.string(),
  isDeleted: z.boolean().optional(),
});
const GoalItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  label: z.string(),
  softDeleted: z.boolean().optional(),
  valueType: z.enum(ValueType).or(z.literal('')),
});

export const MetaResponseSchema = z.object({
  rows: z.object({
    channels: z.array(MetaItemSchema),
  }),
  columns: z
    .object({
      activeDays: z.array(MetaItemSchema),
      device: z.array(MetaItemSchema).optional(),
      format: z.array(MetaItemSchema),
      funnelStrategy: z.array(z.string()),
      itemGoal: z.object({
        adServer: z.array(GoalItemSchema),
        analytics: z.array(GoalItemSchema),
        dataImportHub: z.array(GoalItemSchema),
        displayCampaign: z.array(GoalItemSchema),
        ghostCampaign: z.array(GoalItemSchema),
        searchCampaign: z.array(GoalItemSchema),
        socialCampaign: z.array(GoalItemSchema),
        videoCampaign: z.array(GoalItemSchema),
      }),
      mobileOs: z.array(MetaItemSchema),
      network: z.array(MetaItemSchema),
      objective: z.array(MetaItemSchema),
      otl: z.array(MetaItemSchema),
      partner: z.array(MetaItemSchema),
      pricingType: z.array(MetaItemSchema),
      typeOfBuying: z.array(MetaItemSchema),
    })
    .catchall(z.array(MetaItemSchema)),
});

export type BuyingPlanLite = z.infer<typeof BuyingPlanLiteSchema>;
export type UpdateBuyingPlanNamePayload = {
  buyingPlanId: number;
  buyingPlanName: string;
};
export type MetaResponse = z.infer<typeof MetaResponseSchema>;
export type ColumnItem = z.infer<typeof MetaItemSchema>;

export type TechCostColumn = {
  name: string;
  techCostPercent?: number | null;
  isAutoCalculationEnabled: boolean;
};
